<template>
    <div class="auto-complete" 
        @keydown.up="optionHandler('up')" 
        @keydown.down="optionHandler('down')" 
        @keydown.enter="optionHandler('clickByEnter')"
        :class="{
            'auto-complete--sravni': this.page === 'sravni',
            'auto-complete--sravni-disabled': this.type === 'disabled',
            'auto-complete--makc': this.page === 'req',
            'auto-complete--required': this.type === 'required'
        }"
    >      
        <label class="auto-complete__label" v-if="this.showLabel" for="autocomplete"> {{ this.label }} </label>

        <input class="auto-complete__input"
            :value="modelValue" 
            @input="manualInsert" 
            :placeholder="this.placeholder" :disabled="this.type === 'disabled'" type="number" id="autocomplete"
        > 

        <div class="auto-complete__select auto-complete__select--kladr" v-show="this.showSelect">
            <div class="auto-complete__select-option auto-complete__select-option"
                v-for="[index, item] of this.options.entries()" :key="index" :value=item.BIK
                @mouseover="this.currentOptionIndex = index"
                @click="optionHandler('click', item)"
                refs="items"                 
                :class="{'auto-complete__select-option--current': this.currentOptionIndex === index}" 
            >
                {{ item.BIK + ', ' +item.NAMEMINI }}
            </div>
        </div>
        <label class="auto-complete__error" 
            v-if="this.showErr" for="autocomplete"
        >
            {{ this.errText }}
        </label> 
    </div>
</template>

<script>
export default {
	props: {
        page: [String],
        type: [String],
        options: [Array],
        modelValue: [String],
        showLabel: {
            type: Boolean,
            default: "true",
        },
        label: {
            type: String,
            default: "labelText",
        },
        placeholder: {
            type: String,
            default: "placeholderText",
        },
        showErr: {
            type: Boolean,
            default: "false",
        },
        errText: {
            type: String,
            default: "errText",
        },     
    },
	data() {
		return {
            showSelect: false,
            currentOptionIndex: '',
            isSelected: false,
		};
	},
	methods: {
        manualInsert(event) {
            this.currentOptionIndex = '';
            this.isSelected = false;
            
            const emptyItem = {BIK: '', KS: '', NAMEMINI: ''};
            this.$emit('updateItem', emptyItem);
            
            this.$emit('update:modelValue', event.target.value);
		},
        optionHandler(action, item) {
            if (action === 'click') {
                this.$emit('updateItem', item);
                this.$emit('update:modelValue', item.BIK);
                this.showSelect = false; 
                this.isSelected = true;
            } 
            else if (action === 'clickByEnter') {
                if (this.currentOptionIndex.length === 0) return

                const i = this.options[this.currentOptionIndex];
                this.$emit('updateItem', i);
                this.$emit('update:modelValue', i.BIK);
                this.showSelect = false; 
                this.isSelected = true;
            } 
            else if (action === 'up') {
                if (this.currentOptionIndex.length === 0) {
                    this.currentOptionIndex = 0;
                } 
                else if (this.currentOptionIndex !== 0) {
                    this.currentOptionIndex -= 1
                }
            }
            else if (action === 'down') {
                if (this.currentOptionIndex.length === 0) {
                    this.currentOptionIndex = 0;
                } 
                else if (this.currentOptionIndex !== this.options.length - 1) {
                    this.currentOptionIndex += 1
                }
            }
        }
	},
    watch: {
        options(val) {
            if (val.length === 0 || this.modelValue === '' || this.isSelected) {
                this.showSelect = false;} 
            else {
                this.showSelect = true}
        },
    },
}
</script>
<style lang="scss">
@import "@/create/assets/scss/style.scss";
</style>
